import {DoraProperty} from '../../../Decorators/Decorator';

export class Tupla {
  @DoraProperty
  public unitSx = '';

  @DoraProperty
  public key = '';

  @DoraProperty
  public unitDx = '';

  @DoraProperty
  public format = '';
}
